// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powered-by-cinch {
  flex-shrink: 0;
  text-align: center;
  padding: 8px 16px;
  font-size: 11px;
  line-height: 1.4;
  letter-spacing: 0.02em;
  color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/PoweredByCinch.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".powered-by-cinch {\n  flex-shrink: 0;\n  text-align: center;\n  padding: 8px 16px;\n  font-size: 11px;\n  line-height: 1.4;\n  letter-spacing: 0.02em;\n  color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
